import { render, staticRenderFns } from "./fundDatagramDetail.vue?vue&type=template&id=91cb5f70&scoped=true"
import script from "./fundDatagramDetail.vue?vue&type=script&lang=js"
export * from "./fundDatagramDetail.vue?vue&type=script&lang=js"
import style0 from "./fundDatagramDetail.vue?vue&type=style&index=0&id=91cb5f70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91cb5f70",
  null
  
)

export default component.exports